import {
  SET_DISCOUNT_RECOMMEND_LIST,
  SET_DISCOUNT_RANK_LIST,
  SET_DISCOUNT_RANK_MENU,
  SET_DISCOUNT_RANK_TYPE,
  SET_DISCOUNT_RANK_ORDER,
} from '../constants/discount';
import { setItemToShortestList, changeItemStyleTypeDependOnType } from '../utils/utils';

const initState = {
  rankAppList: {
    list: [],
    list2: [],
    list3: [],
    list4: [],
    pageCursor: '',
    loading: true,
  },
  rankAppMenu: {},
  selectType: null,
  selectOrder: null,
  recommendAppList: {
    pageCursor: '',
    loading: true,
    line2List: [
      { height: 0, cardList: [] },
      { height: 0, cardList: [] },
    ],
    line3List: [
      { height: 0, cardList: [] },
      { height: 0, cardList: [] },
      { height: 0, cardList: [] },
    ],
    line4List: [
      { height: 0, cardList: [] },
      { height: 0, cardList: [] },
      { height: 0, cardList: [] },
      { height: 0, cardList: [] },
    ],
  },
};

const discount = (state = initState, action = {}) => {
  switch (action.type) {
    // 先预留一个位置处理排行榜页面的多维数组
    case SET_DISCOUNT_RANK_LIST:
      let rList = action.data?.data?.commodities;
      rList?.forEach((item, index) => {
        item.i = index + 1;
      });
      let rList2 = action.data.refresh ? [] : state.rankAppList.list2;
      let rList3 = action.data.refresh ? [] : state.rankAppList.list3;
      let rList4 = action.data.refresh ? [] : state.rankAppList.list4;
      if (rList2?.[rList2.length - 1]?.length < 2) {
        let Length = 2 - rList2?.[rList2.length - 1]?.length;
        let sliceA = rList.slice(0, Length);
        rList2[rList2.length - 1].push(...sliceA);
      } else {
        for (let i = 0; i < rList?.length; i++) {
          rList2.push(rList?.slice(i, i + 2));
          i = i + 1;
        }
      }
      if (rList3?.[rList3.length - 1]?.length < 3) {
        let Length = 3 - rList3?.[rList3.length - 1]?.length;
        let sliceA = rList.slice(0, Length);
        rList3[rList3.length - 1].push(...sliceA);
      } else {
        for (let i = 0; i < rList?.length; i++) {
          rList3.push(rList?.slice(i, i + 3));
          i = i + 2;
        }
      }
      if (rList4?.[rList4.length - 1]?.length < 4) {
        let Length = 4 - rList4?.[rList4.length - 1]?.length;
        let sliceA = rList.slice(0, Length);
        rList4[rList4.length - 1].push(...sliceA);
      } else {
        for (let i = 0; i < rList?.length; i++) {
          rList4.push(rList?.slice(i, i + 4));
          i = i + 3;
        }
      }
      return {
        ...state,
        rankAppList: {
          list: rList,
          list2: rList2,
          list3: rList3,
          list4: rList4,
          pageCursor: action.data?.data?.pageCursor ?? '',
          loading: action.data.loading,
        },
      };
    case SET_DISCOUNT_RECOMMEND_LIST:
      if (action.payload.loading) {
        return {
          ...state,
          recommendAppList: {
            ...state.recommendAppList,
            loading: true,
          },
        };
      }
      if (action.payload.refresh) {
        return {
          ...state,
          recommendAppList: {
            pageCursor: null,
            loading: true,
            refresh: true,
            line2List: [
              { height: 0, cardList: [] },
              { height: 0, cardList: [] },
            ],
            line3List: [
              { height: 0, cardList: [] },
              { height: 0, cardList: [] },
              { height: 0, cardList: [] },
            ],
            line4List: [
              { height: 0, cardList: [] },
              { height: 0, cardList: [] },
              { height: 0, cardList: [] },
              { height: 0, cardList: [] },
            ],
          },
        };
      }
      let list2 = state.recommendAppList.line2List || [[]],
        list3 = state.recommendAppList.line3List || [[]],
        list4 = state.recommendAppList.line4List || [[]];
      action.payload.commodities.forEach(item => {
        if (item) {
          const rankLabels = item.labels?.filter(
            item => item.type?.startsWith('1') || item.type?.startsWith('3'),
          );
          if (rankLabels && rankLabels.length > 2) {
            item.height = 216;
          } else {
            item.height = 191;
          }
          const insertedItem = changeItemStyleTypeDependOnType(item);
          list2 = setItemToShortestList(list2, insertedItem);
          list3 = setItemToShortestList(list3, insertedItem);
          list4 = setItemToShortestList(list4, insertedItem);
        }
      });
      return {
        ...state,
        recommendAppList: {
          loading: false,
          pageCursor: action.payload.pageCursor,
          line2List: list2,
          line3List: list3,
          line4List: list4,
        },
      };
    case SET_DISCOUNT_RANK_MENU:
      return { ...state, rankAppMenu: action.data };
    case SET_DISCOUNT_RANK_ORDER:
      return { ...state, selectOrder: action.payload };
    case SET_DISCOUNT_RANK_TYPE:
      return { ...state, selectType: action.payload };
    default:
      return state;
  }
};

export default discount;
